// Vanilla JavaScript - Migrated from jQuery
document.addEventListener('DOMContentLoaded', function () {
  // Close button for quick information modal
  document.querySelectorAll(".close_btn img").forEach(function(btn) {
    btn.addEventListener('click', function () {
      const quickInfo = document.querySelector(".quick__information");
      if (quickInfo) quickInfo.classList.remove("active");
      document.body.classList.remove("hidescroll");
    });
  });

  // Header actions button
  document.querySelectorAll(".headermain_sec button.header__actions_btn").forEach(function(btn) {
    btn.addEventListener('click', function () {
      document.body.classList.add("hidescroll");
    });
  });

  // Read more/less toggle
  document.querySelectorAll(".read-more-less-action").forEach(function(btn) {
    btn.addEventListener('click', function () {
      const toggleContent = document.querySelector(".read-more-less-toggle-content");
      if (this.classList.contains("active")) {
        this.classList.remove("active");
        if (toggleContent) toggleContent.style.display = 'none';
        this.textContent = "Real More";
      } else {
        this.classList.add("active");
        if (toggleContent) toggleContent.style.display = 'block';
        this.textContent = "Real Less";
      }
    });
  });

  // Add to cart button - opens collection popup
  document.querySelectorAll(".buttonaddtocart button").forEach(function(btn) {
    btn.addEventListener('click', function (e) {
      const productGridItem = this.closest(".product-grid-item");
      // Removed empty classList.add('') - empty strings are not valid class names
      this.classList.add('active');
      document.body.classList.add('overflow-hidden');
      
      const collectionPopup = document.querySelector('.collection-popup');
      if (collectionPopup) {
        collectionPopup.classList.add('active');
        collectionPopup.classList.add('loading');
      }
      
      if (e.target.dataset.handle) {
        document.body.classList.add(e.target.dataset.handle);
      }
      
      // Ensure simply object exists
      if (!window.simply) {
        window.simply = {};
      }
      if (e.target.dataset.handle) {
        simply.prodHandle = e.target.dataset.handle;
      }
      
      if (e.target.dataset.url) {
        fetch(e.target.dataset.url)
          .then((data) => data.text())
          .then((html) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            const mainProduct = doc.querySelector('.main-product');
            const popupContent = document.querySelector('.collection-popup .collection-popup-content');
            
            if (collectionPopup) collectionPopup.classList.remove('loading');
            if (popupContent && mainProduct) {
              popupContent.innerHTML = mainProduct.outerHTML;
            }
          });
      }
    });
  });

  // Close collection popup
  document.querySelectorAll('.close-btn-js').forEach(function(btn) {
    btn.addEventListener('click', function () {
      const collectionPopup = this.closest(".collection-popup");
      if (collectionPopup) collectionPopup.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      
      // Add fallback for simply object
      if (window.simply && window.simply.prodHandle) {
        document.body.classList.remove(window.simply.prodHandle);
      }
    });
  });

  // Close variant selector
  document.querySelectorAll(".close-var img, .close-var").forEach(function(btn) {
    btn.addEventListener('click', function () {
      const productGridItem = this.closest(".product-grid-item");
      if (productGridItem) productGridItem.classList.remove('active');
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    });
  });

  // Variant gummy container selection
  document.querySelectorAll(".col-varinats .variant-gummy-container").forEach(function(container) {
    container.addEventListener('click', function () {
      const collectionVariants = this.closest(".collection-variants");
      if (collectionVariants) {
        // Remove selected from all variants in this group
        collectionVariants.querySelectorAll(".col-varinats .variant-gummy-container").forEach(function(v) {
          v.classList.remove("selected");
        });
        
        // Add selected to clicked variant
        this.classList.add("selected");
        
        // Get selected variant ID
        const selectedVariant = collectionVariants.querySelector(".col-varinats .variant-gummy-container.selected");
        if (selectedVariant) {
          const variantid = selectedVariant.getAttribute('col-var-id');
          const addToCartBtn = collectionVariants.querySelector(".collection-add-to-cart-variant");
          if (addToCartBtn && variantid) {
            addToCartBtn.setAttribute('var-btn', variantid);
          }
          
          // Update form input
          const productGridItem = this.closest('.product-grid-item');
          if (productGridItem) {
            const formInput = productGridItem.querySelector('form [name="id"]');
            if (formInput) formInput.value = variantid;
          }
        }
      }
    });
  });

  // Collection add to cart variant button
  document.querySelectorAll(".collection-add-to-cart-variant").forEach(function(btn) {
    btn.addEventListener('click', function () {
      const productGridItem = this.closest('.product-grid-item');
      if (productGridItem) {
        const singleButton = productGridItem.querySelector('form .single_button');
        if (singleButton) singleButton.click();
      }
    });
  });

  // Review widget and variant price updates
  setTimeout(function () {
    const reviewTextEl = document.querySelector('.jdgm-prev-badge__text');
    const reviewText = reviewTextEl ? reviewTextEl.textContent : '';
    
    const reviewSec = document.querySelector('.ReviewGet-Sec');
    const reviewHtml = reviewSec ? reviewSec.innerHTML : '';
    const priceBoxWrapper = document.querySelector('.price__box_wrapper');
    
    if (priceBoxWrapper && reviewHtml) {
      const reviewContainer = document.createElement('div');
      reviewContainer.className = 'review-container';
      reviewContainer.innerHTML = reviewHtml;
      priceBoxWrapper.parentNode.insertBefore(reviewContainer, priceBoxWrapper);
    }

    // Variant radios label click handler
    document.querySelectorAll("variant-radios label:not(.flavours-swatch)").forEach(function(label) {
      label.addEventListener('click', function () {
        const pricevalue = this.dataset.price ? parseFloat(this.dataset.price) : 0;
        const datapack = this.dataset.pack;
        
        console.log("pricevalue", pricevalue);
        var totalprice = pricevalue - 100;
        const discountBanner = document.getElementById('wuwEffectiveDiscountInBanner');
        if (discountBanner) discountBanner.textContent = totalprice;

        setTimeout(function () {
          if (reviewTextEl) reviewTextEl.textContent = reviewText;
        }, 500);
      });
    });
  }, 1000);

  // Discount code monitoring
  setInterval(function () {
    const targetElement = document.querySelector('[data-est-total]');
    const discountElement = document.querySelector('[data-code="10PERCENTOFF"]');
    
    const beanContainer = document.querySelector('.docapp-coupon-input--bean-container');
    const inputContainer = document.querySelector('.docapp-coupon-input--input-container');
    const summaryNote = document.querySelector('.docapp-cart-item.docapp-summary-note');
    
    if (beanContainer) {
      if (beanContainer.children.length === 0) {
        if (inputContainer) inputContainer.style.display = 'block';
        if (summaryNote) summaryNote.style.display = 'block';
      } else if (beanContainer.children.length === 1) {
        const checkDiscountElement = beanContainer.querySelector(".docapp-coupon-input--bean-container--bean-remove");
        if (checkDiscountElement) {
          const discount = checkDiscountElement.getAttribute('data-code');
          if (discount == "10PERCENTOFF") {
            if (inputContainer) inputContainer.style.display = 'block';
            if (summaryNote) summaryNote.style.display = 'block';
          } else {
            if (inputContainer) inputContainer.style.display = 'none';
            if (summaryNote) summaryNote.style.display = 'none';
          }
        }
      } else {
        if (inputContainer) inputContainer.style.display = 'none';
        if (summaryNote) summaryNote.style.display = 'none';
      }
    }

    const appliedDiscount = document.querySelector('.applied-discount');
    if (targetElement == null) {
      // No discount applied
    } else {
      if (appliedDiscount) appliedDiscount.style.display = 'block';
    }
  }, 500);
});

// Cart count initialization
document.addEventListener('DOMContentLoaded', function () {
  const upcartHeaderText = document.querySelector('.upcart-header-text');
  const itemCount = upcartHeaderText ? upcartHeaderText.textContent : '0';
  const numberOnly = itemCount.match(/\d+/) ? itemCount.match(/\d+/)[0] : '0';
  const myElement = document.getElementById('myElement');
  const isClass = myElement ? myElement.classList.contains('highlight') : false;
  
  if (parseInt(numberOnly) > 0 && !isClass) {
    const cartBubble = document.querySelector('.cart-count-bubble');
    if (cartBubble) cartBubble.classList.add("header__actions_btn_cart_num");
  }

  document.querySelectorAll('.product__add__cart__button').forEach(function(btn) {
    btn.addEventListener('click', function () {
      const upcartHeaderText = document.querySelector('.upcart-header-text');
      const itemCount = upcartHeaderText ? upcartHeaderText.textContent : '0';
      const numberOnly = itemCount.match(/\d+/) ? itemCount.match(/\d+/)[0] : '0';

      if (numberOnly == '0') {
        const cartBubble = document.querySelector('.cart-count-bubble');
        if (cartBubble) cartBubble.classList.add("header__actions_btn_cart_num");
      }
    });
  });
});

// Review widget scroll
setTimeout(function () {
  function smoothScrollToElement(el) {
    var startY = window.pageYOffset;
    var targetY = el.getBoundingClientRect().top + startY;
    var distance = targetY - startY;
    var duration = 600;
    var startTime = null;
    function step(currentTime) {
      if (startTime === null) startTime = currentTime;
      var elapsed = currentTime - startTime;
      var progress = Math.min(elapsed / duration, 1);
      progress = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
      window.scrollTo(0, startY + distance * progress);
      if (elapsed < duration) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  document.querySelectorAll('.review-container, .ReviewGet-Sec').forEach(function(container) {
    container.addEventListener('click', function () {
      var reviewsSection = document.getElementById('judgeme_product_reviews');
      if (reviewsSection) smoothScrollToElement(reviewsSection);
    });
  });
}, 4000);

// Cart button section
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.cart_btnsec').forEach(function(btn) {
    btn.addEventListener('click', function () {
      const minicart = document.querySelector('open-minicart');
      if (minicart) minicart.click();
      
      // Load cart button section content
      fetch(location.href)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCartBtnSec = doc.querySelector('.cart_btnsec');
          if (newCartBtnSec && btn.parentNode) {
            btn.outerHTML = newCartBtnSec.outerHTML;
          }
        })
        .catch(err => console.error('Error loading cart button:', err));
    });
  });
});

// Cart notification close
document.addEventListener('DOMContentLoaded', function() {
  const closeBtn = document.querySelector('.cart-notification__header button.cart-notification__close.modal__close-button.link.link--text.focus-inset');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      const closeBtnImg = document.querySelector(".close_btn img");
      if (closeBtnImg) closeBtnImg.click();
    });
  }
});

// Combo navigation
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.combo-nav-click').forEach(function(btn) {
    btn.addEventListener('click', function () {
      const overlay = document.querySelector(".overlay-combos-menu");
      if (overlay) overlay.style.display = 'block';
    });
  });
  
  document.querySelectorAll('.combo-nav-return').forEach(function(btn) {
    btn.addEventListener('click', function () {
      const overlay = document.querySelector(".overlay-combos-menu");
      if (overlay) overlay.style.display = 'none';
    });
  });
});

// Filter activation
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.js-filter').forEach(function(filter) {
    filter.addEventListener('click', function () {
      this.classList.add("active");
    });
  });
});

// Cart operations
document.addEventListener('DOMContentLoaded', function() {
  // Cart close button handler
  document.addEventListener('click', function(e) {
    if (e.target.closest('.upcart-header-close-button') || e.target.closest('.styles_CartPreview__backdrop__CjzdP')) {
      e.preventDefault();
      console.log('ifff');

      const upcartHeaderText = document.querySelector('.upcart-header-text');
      const itemCount = upcartHeaderText ? upcartHeaderText.textContent : '0';
      const numberOnly = itemCount.match(/\d+/) ? itemCount.match(/\d+/)[0] : '0';

      const cartBubble = document.querySelector('.cart-count-bubble');
      const cartNotificationCount = document.getElementById('cart-notification-count');
      
      if (numberOnly == '0') {
        if (cartBubble) cartBubble.classList.remove("header__actions_btn_cart_num");
        if (cartNotificationCount) cartNotificationCount.textContent = '';
      } else {
        if (cartNotificationCount) cartNotificationCount.textContent = numberOnly;
      }

      // Swiper reinitialization
      const swiperEl = document.querySelector('.product-image-swiper');
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.destroy();
        setTimeout(function () {
          if (typeof Swiper !== 'undefined') {
            new Swiper('.product-image-swiper', {
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              loop: true,
              pagination: {
                el: ".swiper-pagination",
                clickable: true
              },
              autoplay: {
                delay: 4000,
                disableOnInteraction: false
              }
            });
          }
        }, 200);
      }

      // Fetch cart data
      fetch('/cart.js', {
        method: 'GET',
        cache: 'no-cache'
      })
        .then(response => response.json())
        .then(cart => {
          console.log('cart', cart);
          const cartBubbleEl = document.querySelector('.site-header__cart-bubble');
          if (cart.item_count > 0) {
            if (cartBubbleEl) cartBubbleEl.classList.add('site-header__cart-bubble--visible');
          } else {
            if (cartBubbleEl) cartBubbleEl.classList.remove('site-header__cart-bubble--visible');
          }
        })
        .catch(err => console.error('Error fetching cart:', err));

      return false;
    }
  });

  // Product add to cart button
  document.querySelectorAll('.product__add-to-cart-button').forEach(function(btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      document.body.classList.remove('upcartPopupShow');
      
      const masterSelect = document.querySelector('.product-form__master-select');
      const data_val = masterSelect ? masterSelect.options[masterSelect.selectedIndex].value : '';
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          quantity: 1,
          id: data_val
        })
      })
        .then(response => response.json())
        .then(data => {
          const cartToggle = document.querySelector('.ajax-cart__toggle');
          if (cartToggle) cartToggle.click();
          
          console.log('ifff');
          window.upcartShouldSkipAddToCartInterceptor = true;
          document.body.classList.remove('upcartPopupShow');
          
          const cartBubble = document.querySelector('.site-header__cart-bubble');
          if (cartBubble) cartBubble.classList.add('site-header__cart-bubble--visible');
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
  });

  // Discount code badge close
  document.querySelectorAll('.DiscountCodeBadge_close__256WN').forEach(function(btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const cartDrawer = this.closest('.cart-drawer-remove-discount');
      if (cartDrawer) {
        const clearBtn = cartDrawer.querySelector('.clear-discount-btn');
        if (clearBtn) clearBtn.click();
      }
    });
  });

  // Event delegation for dynamically added discount badges
  document.addEventListener('click', function(e) {
    if (e.target.closest('.DiscountCodeBadge_close__256WN')) {
      e.preventDefault();
      const cartDrawer = e.target.closest('.cart-drawer-remove-discount');
      if (cartDrawer) {
        const clearBtn = cartDrawer.querySelector('.clear-discount-btn');
        if (clearBtn) clearBtn.click();
      }
    }
  });
});

// Window load event
window.addEventListener('load', function () {
  setTimeout(function () {
    const upcartHeaderText = document.querySelector('.upcart-header-text');
    const itemCount = upcartHeaderText ? upcartHeaderText.textContent : '0';
    const numberOnly = itemCount.match(/\d+/) ? itemCount.match(/\d+/)[0] : '0';

    const cartBubble = document.querySelector('.cart-count-bubble');
    const cartNotificationCount = document.getElementById('cart-notification-count');
    
    if (numberOnly == '0') {
      if (cartBubble) cartBubble.classList.remove("header__actions_btn_cart_num");
      if (cartNotificationCount) cartNotificationCount.textContent = '';
    } else {
      if (cartNotificationCount) cartNotificationCount.textContent = numberOnly;
    }

    // Cart discount drawer wrap click
    document.addEventListener('click', function(e) {
      const discountLink = e.target.closest('.cart-discount-drawer-wrap h4 a');
      if (discountLink) {
        e.preventDefault();
        const drawerWrap = discountLink.closest('.cart-discount-drawer-wrap');
        if (drawerWrap) {
          const discountText = drawerWrap.querySelector('.cart-discount-drawer-wrap-bottom p');
          const data_disc = discountText ? discountText.textContent.trim() : '';
          
          drawerWrap.classList.add('active');
          
          const discountInput = document.getElementById('discount-code-input');
          if (discountInput) discountInput.value = data_disc;
          
          const applyBtn = document.getElementById('apply-discount-btn');
          if (applyBtn) applyBtn.click();

          setTimeout(function () {
            const errorEl = document.getElementById('discount-code-error');
            const dis_text = errorEl ? errorEl.textContent : '';

            if (dis_text == '') {
              const closeBtn = document.querySelector('.cart-drawer-appy-coupon-close');
              if (closeBtn) closeBtn.click();
              window.upcartShouldSkipAddToCartInterceptor = true;
              if (window.upcartRegisterAddToCart) window.upcartRegisterAddToCart();
            }
          }, 2500);

          setTimeout(function () {
            document.querySelectorAll('.cart-drawer-remove-discount').forEach(function(el) {
              el.classList.remove('active');
              el.style.display = 'none';
            });
            
            // Load docapp cart widget
            const docappWidget = document.querySelector('.docapp-cart-with-coupon-summary.docapp-widget');
            if (docappWidget) {
              fetch(location.href)
                .then(response => response.text())
                .then(html => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, 'text/html');
                  const newWidget = doc.querySelector('.docapp-cart-with-coupon-summary.docapp-widget');
                  if (newWidget) {
                    docappWidget.innerHTML = newWidget.innerHTML;
                  }
                })
                .catch(err => console.error('Error loading widget:', err));
            }
          }, 1800);
        }
      }
    });

    // Apply discount button
    document.addEventListener('click', function(e) {
      if (e.target.closest('#apply-discount-btn')) {
        setTimeout(function () {
          const errorEl = document.getElementById('discount-code-error');
          const dis_text = errorEl ? errorEl.textContent : '';
          
          if (dis_text == '') {
            const closeBtn = document.querySelector('.cart-drawer-appy-coupon-close');
            if (closeBtn) closeBtn.click();
            window.upcartShouldSkipAddToCartInterceptor = true;
            if (window.upcartRegisterAddToCart) window.upcartRegisterAddToCart();
          }
        }, 2500);
        
        setTimeout(function () {
          document.querySelectorAll('.cart-drawer-remove-discount').forEach(function(el) {
            el.classList.remove('active');
            el.style.display = 'none';
          });
        }, 1800);
      }
    });

    // Cart drawer apply coupon
    document.addEventListener('click', function(e) {
      if (e.target.closest('.cart-drawer-appy-coupon')) {
        e.preventDefault();
        document.body.classList.add('cart-discount-drawer-body');
      }
    });

    // Cart drawer apply coupon close
    document.addEventListener('click', function(e) {
      if (e.target.closest('.cart-drawer-appy-coupon-close')) {
        e.preventDefault();
        document.body.classList.remove('cart-discount-drawer-body');
      }
    });

    // Clear discount button
    document.addEventListener('click', function(e) {
      if (e.target.closest('.clear-discount-btn')) {
        document.querySelectorAll('.cart-discount-drawer-wrap').forEach(function(el) {
          el.classList.remove('active');
        });
        
        const cartDrawer = e.target.closest('.cart-drawer-remove-discount');
        if (cartDrawer) {
          const discountText = cartDrawer.querySelector('.cart-discount-drawer-wrap-bottom p');
          const cart_code = discountText ? discountText.textContent.trim() : '';
          
          fetch("/discount/CLEAR");
          localStorage.removeItem('discountCode');
          
          document.querySelectorAll('.cart-discount-drawer-wrap').forEach(function(el) {
            el.classList.remove('active');
          });
          
          console.log('iff');

          setTimeout(function () {
            document.querySelectorAll('.cart-drawer-remove-discount').forEach(function(el) {
              el.classList.remove('active');
              el.style.display = 'none';
            });
          }, 1200);
        }
      }
    });
  }, 100);
});
